/**
 * @summary  Indicates the current row status.
 */
export enum RowStatus
{
    None = 0,
    Added = 1,
    Deleted = 2,
    DeletedPending = 3
}